export default {
	data() {
		return {
			paginationSettings: {},
			paginationOptions: [20, 30, 50, 100],
			defaultItemsPerPage: 20
		};
	},
	methods: {
		getLogKey() {
			return this.logKey || "changeLog";
		},

		getUploadLog(idx) {
			const upload = this.uploads[idx];
			if (!upload) {
				return [];
			}

			const log = upload[this.getLogKey()];
			return Array.isArray(log) ? log : [];
		},

		initializePaginationSettings() {
			this.uploads.forEach((upload, idx) => {
				if (Array.isArray(upload[this.getLogKey()])) {
					this.initializePaginationForUpload(idx);
				}
			});
		},

		initializePaginationForUpload(idx) {
			if (!this.paginationSettings[idx]) {
				this.$set(this.paginationSettings, idx, {
					currentPage: 1,
					itemsPerPage: this.defaultItemsPerPage
				});
			}
		},

		getPaginationSettings(idx) {
			if (!this.paginationSettings[idx]) {
				this.initializePaginationForUpload(idx);
			}
			return this.paginationSettings[idx];
		},

		getTotalChanges(idx) {
			return this.getUploadLog(idx).length;
		},

		getTotalPages(idx) {
			const settings = this.getPaginationSettings(idx);
			const totalChanges = this.getTotalChanges(idx);
			return Math.ceil(totalChanges / settings.itemsPerPage) || 1;
		},

		showPagination(idx) {
			const settings = this.getPaginationSettings(idx);
			return this.getTotalChanges(idx) > settings.itemsPerPage;
		},

		getDisplayStart(idx) {
			const totalChanges = this.getTotalChanges(idx);
			if (totalChanges === 0) {
				return 0;
			}

			const settings = this.getPaginationSettings(idx);
			return (settings.currentPage - 1) * settings.itemsPerPage + 1;
		},

		getDisplayEnd(idx) {
			const settings = this.getPaginationSettings(idx);
			const totalChanges = this.getTotalChanges(idx);
			const end = settings.currentPage * settings.itemsPerPage;
			return Math.min(end, totalChanges);
		},

		getPaginatedChanges(idx) {
			const log = this.getUploadLog(idx);
			const settings = this.getPaginationSettings(idx);
			const start = (settings.currentPage - 1) * settings.itemsPerPage;
			const end = start + settings.itemsPerPage;
			return log.slice(start, end);
		},

		handlePageChange(idx, pageNum) {
			const settings = this.getPaginationSettings(idx);
			settings.currentPage = pageNum;
			this.$forceUpdate();
			this.scrollToChanges(idx);
		},

		handleItemsPerPageChange(idx) {
			const settings = this.getPaginationSettings(idx);
			settings.currentPage = 1;
			this.$forceUpdate();
		},

		scrollToChanges(idx) {
			this.$nextTick(() => {
				const containers = this.$el.querySelectorAll(".changes-container");
				const container = containers[idx];
				if (container) {
					container.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/paginatedUploadsMixin.js